import { AuthLevel, generateApiPath } from '@guiker/api-definition'

export const paths = {
  conversations: generateApiPath({ prefix: AuthLevel.AUTH, name: 'conversation' }),
  stats: generateApiPath({ prefix: AuthLevel.AUTH, name: 'stat' }),
}
